import { useQuery } from '@tanstack/react-query';
import { fetchLivePosition, type GraphFilters } from '../services/graphApi';

export function useLivePositionQuery(
  eventId: number | null,
  refreshIntervalMs = 0,
  filters?: GraphFilters
) {
  return useQuery({
    queryKey: ['live-position', eventId, filters],
    queryFn: () => fetchLivePosition(eventId ?? 0, filters),
    enabled: eventId != null,
    refetchInterval: refreshIntervalMs > 0 ? refreshIntervalMs : false,
  });
}
